import { render, staticRenderFns } from "./fourthindex.vue?vue&type=template&id=3347fb1e&scoped=true&"
import script from "./fourthindex.vue?vue&type=script&lang=js&"
export * from "./fourthindex.vue?vue&type=script&lang=js&"
import style0 from "./fourthindex.vue?vue&type=style&index=0&id=3347fb1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347fb1e",
  null
  
)

export default component.exports